/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountData
 */
export interface AccountData {
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    version?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof AccountData
     */
    editedAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    editedBy?: string | null;
    /**
     * 
     * @type {AccountDataStatusEnum}
     * @memberof AccountData
     */
    status?: AccountDataStatusEnum | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    crmSubmissionId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    expiringSubmissionUuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    renewalSubmissionUuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    agoraId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    uwbId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    masterPolicy?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    policyId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    uwy?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    techExId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    account?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    broker?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    underwriter?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    renewalUnderwriter?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    product?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AccountData
     */
    inceptionDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AccountData
     */
    expiryDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    expiringCurrency?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    gwp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    gnwpEur?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccountData
     */
    multinationalFlag?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    crmRenewalId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    uwbRenewalId?: string | null;
    /**
     * 
     * @type {AccountDataRenewalStatusEnum}
     * @memberof AccountData
     */
    renewalStatus?: AccountDataRenewalStatusEnum | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    renewalAgoraStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    renewalAgoraSubStatus?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    renewalGwp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    renewalGnwp?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    renewalCurrency?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AccountData
     */
    renewalInceptionDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AccountData
     */
    renewalExpiryDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    expiringShare?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    expiringExposure?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    expiringDeductible?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    expiringLimit?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    renewalAptp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    renewalShare?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    renewalExposure?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    renewalDeductible?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    renewalLimit?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    repricingFacilityErc?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    manualErc?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    scoreAts?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    hazardGrade?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    historicalUlr?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    percentUsExposure?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    triggerProductsLiability?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    usExposure?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    peuExposure?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    percentUsMarketCap?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    historicalIlr?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    dnvHull?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    aalOnPremium?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    oarr?: number | null;
    /**
     * 
     * @type {AccountDataLeadFollowEnum}
     * @memberof AccountData
     */
    leadFollow?: AccountDataLeadFollowEnum | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    overallClientGcCHistoricalIlr?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    mflTivRatio?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    socratesScore?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccountData
     */
    facReinsurance?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    multilineRelationship?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    expectedLossRatio?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    diversification?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    renewalRunningDays?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    purePremiumChange?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    calculatedPilStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    finalPilStatus?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    targetRateChange?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    retainedGnwp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    riskFactors?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    asIfPremiumExpired?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    effectiveRateChange?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    retentionRate?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    bucketWeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    portfolioWeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    gwpEur?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    prevPilStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    methodology?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    comments?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    customNotes?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    manualOverride?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccountData
     */
    keyAccount?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    manualPilStatus?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccountData
     */
    renewableFlag?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    rationaleChange?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    retentionRateKeyAccounts?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    targetRateChangeKeyAccounts?: number | null;
    /**
     * 
     * @type {object}
     * @memberof AccountData
     */
    metadataComments?: object | null;
    /**
     * 
     * @type {object}
     * @memberof AccountData
     */
    metadataChecks?: object | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    aptp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    primaryExcess?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    piPrimaryExcess?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    piAptp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    piHistoricalUlr?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    piHazardGrade?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    piUsExposure?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    doHistoricalUlr?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    doAptp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    doHazardGrade?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    doPeuExposure?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    doPercentUsMarketCap?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    aalOnPremiumCargo?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    largeFrequency?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    largeLossMargin?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    adjustedVolatility?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    historicalIlr2yrs?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccountData
     */
    overallHistoricalIlr?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    createdBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AccountData
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AccountData
     */
    updatedBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AccountData
     */
    updatedAt?: Date | null;
}


/**
 * @export
 */
export const AccountDataStatusEnum = {
    Open: 'Open',
    Completed: 'Completed',
    NeedsReview: 'NeedsReview'
} as const;
export type AccountDataStatusEnum = typeof AccountDataStatusEnum[keyof typeof AccountDataStatusEnum];

/**
 * @export
 */
export const AccountDataRenewalStatusEnum = {
    Renewed: 'Renewed',
    LostCancelled: 'LostCancelled'
} as const;
export type AccountDataRenewalStatusEnum = typeof AccountDataRenewalStatusEnum[keyof typeof AccountDataRenewalStatusEnum];

/**
 * @export
 */
export const AccountDataLeadFollowEnum = {
    Lead: 'Lead',
    Follow: 'Follow'
} as const;
export type AccountDataLeadFollowEnum = typeof AccountDataLeadFollowEnum[keyof typeof AccountDataLeadFollowEnum];


/**
 * Check if a given object implements the AccountData interface.
 */
export function instanceOfAccountData(value: object): value is AccountData {
    return true;
}

export function AccountDataFromJSON(json: any): AccountData {
    return AccountDataFromJSONTyped(json, false);
}

export function AccountDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'version': json['version'] == null ? undefined : json['version'],
        'editedAt': json['editedAt'] == null ? undefined : (new Date(json['editedAt'])),
        'editedBy': json['editedBy'] == null ? undefined : json['editedBy'],
        'status': json['status'] == null ? undefined : json['status'],
        'country': json['country'] == null ? undefined : json['country'],
        'crmSubmissionId': json['crmSubmissionId'] == null ? undefined : json['crmSubmissionId'],
        'expiringSubmissionUuid': json['expiringSubmissionUuid'] == null ? undefined : json['expiringSubmissionUuid'],
        'renewalSubmissionUuid': json['renewalSubmissionUuid'] == null ? undefined : json['renewalSubmissionUuid'],
        'agoraId': json['agoraId'] == null ? undefined : json['agoraId'],
        'uwbId': json['uwbId'] == null ? undefined : json['uwbId'],
        'masterPolicy': json['masterPolicy'] == null ? undefined : json['masterPolicy'],
        'policyId': json['policyId'] == null ? undefined : json['policyId'],
        'uwy': json['uwy'] == null ? undefined : json['uwy'],
        'techExId': json['techExId'] == null ? undefined : json['techExId'],
        'account': json['account'] == null ? undefined : json['account'],
        'broker': json['broker'] == null ? undefined : json['broker'],
        'underwriter': json['underwriter'] == null ? undefined : json['underwriter'],
        'renewalUnderwriter': json['renewalUnderwriter'] == null ? undefined : json['renewalUnderwriter'],
        'product': json['product'] == null ? undefined : json['product'],
        'inceptionDate': json['inceptionDate'] == null ? undefined : (new Date(json['inceptionDate'])),
        'expiryDate': json['expiryDate'] == null ? undefined : (new Date(json['expiryDate'])),
        'expiringCurrency': json['expiringCurrency'] == null ? undefined : json['expiringCurrency'],
        'gwp': json['gwp'] == null ? undefined : json['gwp'],
        'gnwpEur': json['gnwpEur'] == null ? undefined : json['gnwpEur'],
        'multinationalFlag': json['multinationalFlag'] == null ? undefined : json['multinationalFlag'],
        'crmRenewalId': json['crmRenewalId'] == null ? undefined : json['crmRenewalId'],
        'uwbRenewalId': json['uwbRenewalId'] == null ? undefined : json['uwbRenewalId'],
        'renewalStatus': json['renewalStatus'] == null ? undefined : json['renewalStatus'],
        'renewalAgoraStatus': json['renewalAgoraStatus'] == null ? undefined : json['renewalAgoraStatus'],
        'renewalAgoraSubStatus': json['renewalAgoraSubStatus'] == null ? undefined : json['renewalAgoraSubStatus'],
        'renewalGwp': json['renewalGwp'] == null ? undefined : json['renewalGwp'],
        'renewalGnwp': json['renewalGnwp'] == null ? undefined : json['renewalGnwp'],
        'renewalCurrency': json['renewalCurrency'] == null ? undefined : json['renewalCurrency'],
        'renewalInceptionDate': json['renewalInceptionDate'] == null ? undefined : (new Date(json['renewalInceptionDate'])),
        'renewalExpiryDate': json['renewalExpiryDate'] == null ? undefined : (new Date(json['renewalExpiryDate'])),
        'expiringShare': json['expiringShare'] == null ? undefined : json['expiringShare'],
        'expiringExposure': json['expiringExposure'] == null ? undefined : json['expiringExposure'],
        'expiringDeductible': json['expiringDeductible'] == null ? undefined : json['expiringDeductible'],
        'expiringLimit': json['expiringLimit'] == null ? undefined : json['expiringLimit'],
        'renewalAptp': json['renewalAptp'] == null ? undefined : json['renewalAptp'],
        'renewalShare': json['renewalShare'] == null ? undefined : json['renewalShare'],
        'renewalExposure': json['renewalExposure'] == null ? undefined : json['renewalExposure'],
        'renewalDeductible': json['renewalDeductible'] == null ? undefined : json['renewalDeductible'],
        'renewalLimit': json['renewalLimit'] == null ? undefined : json['renewalLimit'],
        'repricingFacilityErc': json['repricingFacilityErc'] == null ? undefined : json['repricingFacilityErc'],
        'manualErc': json['manualErc'] == null ? undefined : json['manualErc'],
        'scoreAts': json['scoreAts'] == null ? undefined : json['scoreAts'],
        'hazardGrade': json['hazardGrade'] == null ? undefined : json['hazardGrade'],
        'historicalUlr': json['historicalUlr'] == null ? undefined : json['historicalUlr'],
        'percentUsExposure': json['percentUsExposure'] == null ? undefined : json['percentUsExposure'],
        'triggerProductsLiability': json['triggerProductsLiability'] == null ? undefined : json['triggerProductsLiability'],
        'usExposure': json['usExposure'] == null ? undefined : json['usExposure'],
        'peuExposure': json['peuExposure'] == null ? undefined : json['peuExposure'],
        'percentUsMarketCap': json['percentUsMarketCap'] == null ? undefined : json['percentUsMarketCap'],
        'historicalIlr': json['historicalIlr'] == null ? undefined : json['historicalIlr'],
        'dnvHull': json['dnvHull'] == null ? undefined : json['dnvHull'],
        'aalOnPremium': json['aalOnPremium'] == null ? undefined : json['aalOnPremium'],
        'oarr': json['oarr'] == null ? undefined : json['oarr'],
        'leadFollow': json['leadFollow'] == null ? undefined : json['leadFollow'],
        'overallClientGcCHistoricalIlr': json['overallClientGcCHistoricalIlr'] == null ? undefined : json['overallClientGcCHistoricalIlr'],
        'mflTivRatio': json['mflTivRatio'] == null ? undefined : json['mflTivRatio'],
        'socratesScore': json['socratesScore'] == null ? undefined : json['socratesScore'],
        'facReinsurance': json['facReinsurance'] == null ? undefined : json['facReinsurance'],
        'multilineRelationship': json['multilineRelationship'] == null ? undefined : json['multilineRelationship'],
        'expectedLossRatio': json['expectedLossRatio'] == null ? undefined : json['expectedLossRatio'],
        'diversification': json['diversification'] == null ? undefined : json['diversification'],
        'renewalRunningDays': json['renewalRunningDays'] == null ? undefined : json['renewalRunningDays'],
        'purePremiumChange': json['purePremiumChange'] == null ? undefined : json['purePremiumChange'],
        'calculatedPilStatus': json['calculatedPilStatus'] == null ? undefined : json['calculatedPilStatus'],
        'finalPilStatus': json['finalPilStatus'] == null ? undefined : json['finalPilStatus'],
        'targetRateChange': json['targetRateChange'] == null ? undefined : json['targetRateChange'],
        'retainedGnwp': json['retainedGnwp'] == null ? undefined : json['retainedGnwp'],
        'riskFactors': json['riskFactors'] == null ? undefined : json['riskFactors'],
        'asIfPremiumExpired': json['asIfPremiumExpired'] == null ? undefined : json['asIfPremiumExpired'],
        'effectiveRateChange': json['effectiveRateChange'] == null ? undefined : json['effectiveRateChange'],
        'retentionRate': json['retentionRate'] == null ? undefined : json['retentionRate'],
        'bucketWeight': json['bucketWeight'] == null ? undefined : json['bucketWeight'],
        'portfolioWeight': json['portfolioWeight'] == null ? undefined : json['portfolioWeight'],
        'gwpEur': json['gwpEur'] == null ? undefined : json['gwpEur'],
        'prevPilStatus': json['prevPilStatus'] == null ? undefined : json['prevPilStatus'],
        'methodology': json['methodology'] == null ? undefined : json['methodology'],
        'comments': json['comments'] == null ? undefined : json['comments'],
        'customNotes': json['customNotes'] == null ? undefined : json['customNotes'],
        'manualOverride': json['manualOverride'] == null ? undefined : json['manualOverride'],
        'keyAccount': json['keyAccount'] == null ? undefined : json['keyAccount'],
        'manualPilStatus': json['manualPilStatus'] == null ? undefined : json['manualPilStatus'],
        'renewableFlag': json['renewableFlag'] == null ? undefined : json['renewableFlag'],
        'rationaleChange': json['rationaleChange'] == null ? undefined : json['rationaleChange'],
        'retentionRateKeyAccounts': json['retentionRateKeyAccounts'] == null ? undefined : json['retentionRateKeyAccounts'],
        'targetRateChangeKeyAccounts': json['targetRateChangeKeyAccounts'] == null ? undefined : json['targetRateChangeKeyAccounts'],
        'metadataComments': json['metadataComments'] == null ? undefined : json['metadataComments'],
        'metadataChecks': json['metadataChecks'] == null ? undefined : json['metadataChecks'],
        'aptp': json['aptp'] == null ? undefined : json['aptp'],
        'primaryExcess': json['primaryExcess'] == null ? undefined : json['primaryExcess'],
        'piPrimaryExcess': json['piPrimaryExcess'] == null ? undefined : json['piPrimaryExcess'],
        'piAptp': json['piAptp'] == null ? undefined : json['piAptp'],
        'piHistoricalUlr': json['piHistoricalUlr'] == null ? undefined : json['piHistoricalUlr'],
        'piHazardGrade': json['piHazardGrade'] == null ? undefined : json['piHazardGrade'],
        'piUsExposure': json['piUsExposure'] == null ? undefined : json['piUsExposure'],
        'doHistoricalUlr': json['doHistoricalUlr'] == null ? undefined : json['doHistoricalUlr'],
        'doAptp': json['doAptp'] == null ? undefined : json['doAptp'],
        'doHazardGrade': json['doHazardGrade'] == null ? undefined : json['doHazardGrade'],
        'doPeuExposure': json['doPeuExposure'] == null ? undefined : json['doPeuExposure'],
        'doPercentUsMarketCap': json['doPercentUsMarketCap'] == null ? undefined : json['doPercentUsMarketCap'],
        'aalOnPremiumCargo': json['aalOnPremiumCargo'] == null ? undefined : json['aalOnPremiumCargo'],
        'largeFrequency': json['largeFrequency'] == null ? undefined : json['largeFrequency'],
        'largeLossMargin': json['largeLossMargin'] == null ? undefined : json['largeLossMargin'],
        'adjustedVolatility': json['adjustedVolatility'] == null ? undefined : json['adjustedVolatility'],
        'historicalIlr2yrs': json['historicalIlr2yrs'] == null ? undefined : json['historicalIlr2yrs'],
        'overallHistoricalIlr': json['overallHistoricalIlr'] == null ? undefined : json['overallHistoricalIlr'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function AccountDataToJSON(json: any): AccountData {
    return AccountDataToJSONTyped(json, false);
}

export function AccountDataToJSONTyped(value?: AccountData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'version': value['version'],
        'editedAt': value['editedAt'] == null ? value['editedAt'] : value['editedAt'].toISOString(),
        'editedBy': value['editedBy'],
        'status': value['status'],
        'country': value['country'],
        'crmSubmissionId': value['crmSubmissionId'],
        'expiringSubmissionUuid': value['expiringSubmissionUuid'],
        'renewalSubmissionUuid': value['renewalSubmissionUuid'],
        'agoraId': value['agoraId'],
        'uwbId': value['uwbId'],
        'masterPolicy': value['masterPolicy'],
        'policyId': value['policyId'],
        'uwy': value['uwy'],
        'techExId': value['techExId'],
        'account': value['account'],
        'broker': value['broker'],
        'underwriter': value['underwriter'],
        'renewalUnderwriter': value['renewalUnderwriter'],
        'product': value['product'],
        'inceptionDate': value['inceptionDate'] == null ? value['inceptionDate'] : value['inceptionDate'].toISOString().substring(0,10),
        'expiryDate': value['expiryDate'] == null ? value['expiryDate'] : value['expiryDate'].toISOString().substring(0,10),
        'expiringCurrency': value['expiringCurrency'],
        'gwp': value['gwp'],
        'gnwpEur': value['gnwpEur'],
        'multinationalFlag': value['multinationalFlag'],
        'crmRenewalId': value['crmRenewalId'],
        'uwbRenewalId': value['uwbRenewalId'],
        'renewalStatus': value['renewalStatus'],
        'renewalAgoraStatus': value['renewalAgoraStatus'],
        'renewalAgoraSubStatus': value['renewalAgoraSubStatus'],
        'renewalGwp': value['renewalGwp'],
        'renewalGnwp': value['renewalGnwp'],
        'renewalCurrency': value['renewalCurrency'],
        'renewalInceptionDate': value['renewalInceptionDate'] == null ? value['renewalInceptionDate'] : value['renewalInceptionDate'].toISOString().substring(0,10),
        'renewalExpiryDate': value['renewalExpiryDate'] == null ? value['renewalExpiryDate'] : value['renewalExpiryDate'].toISOString().substring(0,10),
        'expiringShare': value['expiringShare'],
        'expiringExposure': value['expiringExposure'],
        'expiringDeductible': value['expiringDeductible'],
        'expiringLimit': value['expiringLimit'],
        'renewalAptp': value['renewalAptp'],
        'renewalShare': value['renewalShare'],
        'renewalExposure': value['renewalExposure'],
        'renewalDeductible': value['renewalDeductible'],
        'renewalLimit': value['renewalLimit'],
        'repricingFacilityErc': value['repricingFacilityErc'],
        'manualErc': value['manualErc'],
        'scoreAts': value['scoreAts'],
        'hazardGrade': value['hazardGrade'],
        'historicalUlr': value['historicalUlr'],
        'percentUsExposure': value['percentUsExposure'],
        'triggerProductsLiability': value['triggerProductsLiability'],
        'usExposure': value['usExposure'],
        'peuExposure': value['peuExposure'],
        'percentUsMarketCap': value['percentUsMarketCap'],
        'historicalIlr': value['historicalIlr'],
        'dnvHull': value['dnvHull'],
        'aalOnPremium': value['aalOnPremium'],
        'oarr': value['oarr'],
        'leadFollow': value['leadFollow'],
        'overallClientGcCHistoricalIlr': value['overallClientGcCHistoricalIlr'],
        'mflTivRatio': value['mflTivRatio'],
        'socratesScore': value['socratesScore'],
        'facReinsurance': value['facReinsurance'],
        'multilineRelationship': value['multilineRelationship'],
        'expectedLossRatio': value['expectedLossRatio'],
        'diversification': value['diversification'],
        'renewalRunningDays': value['renewalRunningDays'],
        'purePremiumChange': value['purePremiumChange'],
        'calculatedPilStatus': value['calculatedPilStatus'],
        'finalPilStatus': value['finalPilStatus'],
        'targetRateChange': value['targetRateChange'],
        'retainedGnwp': value['retainedGnwp'],
        'riskFactors': value['riskFactors'],
        'asIfPremiumExpired': value['asIfPremiumExpired'],
        'effectiveRateChange': value['effectiveRateChange'],
        'retentionRate': value['retentionRate'],
        'bucketWeight': value['bucketWeight'],
        'portfolioWeight': value['portfolioWeight'],
        'gwpEur': value['gwpEur'],
        'prevPilStatus': value['prevPilStatus'],
        'methodology': value['methodology'],
        'comments': value['comments'],
        'customNotes': value['customNotes'],
        'manualOverride': value['manualOverride'],
        'keyAccount': value['keyAccount'],
        'manualPilStatus': value['manualPilStatus'],
        'renewableFlag': value['renewableFlag'],
        'rationaleChange': value['rationaleChange'],
        'retentionRateKeyAccounts': value['retentionRateKeyAccounts'],
        'targetRateChangeKeyAccounts': value['targetRateChangeKeyAccounts'],
        'metadataComments': value['metadataComments'],
        'metadataChecks': value['metadataChecks'],
        'aptp': value['aptp'],
        'primaryExcess': value['primaryExcess'],
        'piPrimaryExcess': value['piPrimaryExcess'],
        'piAptp': value['piAptp'],
        'piHistoricalUlr': value['piHistoricalUlr'],
        'piHazardGrade': value['piHazardGrade'],
        'piUsExposure': value['piUsExposure'],
        'doHistoricalUlr': value['doHistoricalUlr'],
        'doAptp': value['doAptp'],
        'doHazardGrade': value['doHazardGrade'],
        'doPeuExposure': value['doPeuExposure'],
        'doPercentUsMarketCap': value['doPercentUsMarketCap'],
        'aalOnPremiumCargo': value['aalOnPremiumCargo'],
        'largeFrequency': value['largeFrequency'],
        'largeLossMargin': value['largeLossMargin'],
        'adjustedVolatility': value['adjustedVolatility'],
        'historicalIlr2yrs': value['historicalIlr2yrs'],
        'overallHistoricalIlr': value['overallHistoricalIlr'],
        'createdBy': value['createdBy'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedBy': value['updatedBy'],
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
    };
}

